module.exports = __webpack_public_path__ + "img/temperature-arrow-up.f5e95bf3.svg";